import React from 'react';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section 
      id="home"
      style={{
        background: '#000000',
        minHeight: 'calc(100vh - 80px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '100px 7.6923%',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Background grid pattern */}
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 1px, rgba(255, 255, 255, 0.03) 1px, rgba(255, 255, 255, 0.03) calc(100% / 13)),
            repeating-linear-gradient(-90deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03) 1px, transparent 1px, transparent calc(100% / 13))
          `,
          backgroundSize: '100% 100%',
          opacity: 0.4,
          pointerEvents: 'none'
        }}
      />
      
      <div 
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          textAlign: 'center',
          position: 'relative',
          zIndex: 1
        }}
      >
        <h1 
          className="display-huge"
          style={{
            marginBottom: '24px',
            animation: 'fadeInUp 0.8s ease-out'
          }}
        >
          <span style={{ color: '#00FFD1' }}>AI Website Building</span>
        </h1>
        
        <p 
          className="body-large"
          style={{
            maxWidth: '800px',
            margin: '0 auto 40px',
            color: 'rgba(255, 255, 255, 0.85)',
            animation: 'fadeInUp 0.8s ease-out 0.2s backwards'
          }}
        >
          We build stunning, professional landing pages and fullstack applications using Emergent AI—delivering agency-quality websites at a fraction of the cost.
        </p>
        
        <div 
          style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap',
            animation: 'fadeInUp 0.8s ease-out 0.4s backwards'
          }}
        >
          <button
            className="btn-primary"
            onClick={scrollToContact}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '12px'
            }}
          >
            Request a Quote
            <ArrowRight size={20} />
          </button>
          
          <button
            className="btn-secondary"
            onClick={() => {
              const element = document.getElementById('services');
              if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
              }
            }}
          >
            Explore Services
          </button>
        </div>
      </div>
      
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default HeroSection;
